module.exports = __webpack_public_path__ + "img/tableColor.5105702a.svg";